import { render, staticRenderFns } from "./rl-il.vue?vue&type=template&id=53687824&scoped=true&"
import script from "./rl-il.vue?vue&type=script&lang=js&"
export * from "./rl-il.vue?vue&type=script&lang=js&"
import style0 from "./rl-il.vue?vue&type=style&index=0&id=53687824&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53687824",
  null
  
)

export default component.exports